import { BrowserModule } from "@angular/platform-browser";
import { Inject, NgModule, LOCALE_ID } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { LoginComponent } from "./feature/codemodify/login/login.component";
import { SecureCodeModifyComponent } from "./feature/codemodify/modify/secure-code-modify.component";
import { SignComponent } from "./feature/codemodify/sign/sign.component";
import { createLogger } from "redux-logger";
import { LoadingMaskModule } from "./component/loadingmask/loadingmask.module";
import { AppFrameComponent } from "./component/app-frame-component/app-frame.component";
import { AppFrameHeaderComponent } from "./component/app-header/app-header.component";
import { ResourceModule, ResourcePackageToken } from "./feature/core/resource/resource.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MaterialModule, MY_FORMATS } from "./material/material.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SideBarComponent } from "./component/side-bar-component/side-bar.component";
import { CodeModifyModalComponent } from "./feature/codemodify/modify/code-modify-modal.component";
import { ResultModalComponent } from "./component/result-modal/result-modal.component";
import {
  RECAPTCHA_LANGUAGE,
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings
} from "ng-recaptcha";
import { PassVisibilityIconComponent } from "@component/pass-visibilty-icon/pass-visibilty-icon.component";
import { ApiModule } from "../api/api.module";
import { StoreModule } from "@ngrx/store";
import { CoreModule } from "./core/core.module";
import { ReduxConfigService, ReduxConfigServiceToken } from "./core/index";
import { HttpInterceptorsModule } from "./feature/core/httpinterceptors/http-interceptors.module";
import { registerLocaleData } from "@angular/common";
import localeHu from "@angular/common/locales/hu";
import { LocaleServiceConfigToken } from "./core/locale/locale.module";
import { localeConfig, loadingMaskConfig, remoteApiUrl, formatterServiceConfig } from "./app.config";
import { resourcePackage } from "./resource.config";
import { LoadingMaskConfigToken } from "@component/loadingmask/loadingmask.config.model";
import { BASE_PATH } from "../api";
import { FormatterServiceConfigToken } from "@core/formatter/formatter.module";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { environment } from "../environments/environment";
import { SessionModule } from "./feature/core/session/session.module";

registerLocaleData(localeHu, "hu-HU");

@NgModule({
  imports: [
    ApiModule,
    CoreModule,
    ResourceModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    LoadingMaskModule,
    StoreModule.forRoot({}, {}),
    HttpInterceptorsModule,
    SessionModule
  ],
  declarations: [
    AppFrameComponent,
    AppFrameHeaderComponent,
    SideBarComponent,
    LoginComponent,
    SecureCodeModifyComponent,
    CodeModifyModalComponent,
    SignComponent,
    ResultModalComponent,
    PassVisibilityIconComponent
  ],
  providers: [
    {provide: LOCALE_ID, useValue: "hu-HU"},
    {provide: FormatterServiceConfigToken, useValue: formatterServiceConfig},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.siteKey } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: "hu"
    },
    { provide: LocaleServiceConfigToken, useValue: localeConfig },
    { provide: ResourcePackageToken, useValue: resourcePackage, multi: true },
    { provide: LoadingMaskConfigToken, useValue: loadingMaskConfig },
    { provide: BASE_PATH, useValue: remoteApiUrl },
  ],
  bootstrap: [
    AppFrameComponent
  ]
})
export class AppModule {
  constructor(@Inject(ReduxConfigServiceToken) private reduxConfigService: ReduxConfigService) {
  }
}
